<div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-12">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a [routerLink]="['/home']">Home</a>
        </li>
        <li class="breadcrumb-item">
          <a>Sites</a>
        </li>        
        <li class="breadcrumb-item" *ngIf="siteType">
            <a>{{siteType.siteTypeCode}}</a>
          </li>
      </ol>
    </div>
</div>
<div class="wrapper wrapper-content  animated fadeInRight">
    <div class="row">

        <div class="col-lg-12 half-height">
            <div class="card mt-2 bg-emphasis bg-opacity-25">
                <div class="card-body">
                    <tabset>
                        <tab [heading]="siteType?.siteTypeCode">
                            <div class="row mt-2 fixed">
                                <div class="col-lg-12">
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <div class="form-group form-group-sm mt-2 btn-group btn-block">
                                                <input type="text" placeholder="Search inputs by name..." class="form-control form-control-sm" [(ngModel)]="inputFilter" (input)="onInput($event)" (keyup.enter)="doSearch()">
                                                <button type="button" class="btn btn-sm btn-outline-default" (click)="doSearch()"  [disabled]="loading"><i class="fa fa-search"></i> </button>
                                            </div>
                
                                            <div class="d-flex fw-bold small mt-2">
                                                <span class="flex-grow-1">
                                                    <pagination class="float-sm-left " [totalItems]="totalItems" [(ngModel)]="pageIndex" (pageChanged)="pageChange($event)" 
                                                    [disabled]="loading" [maxSize]="maxPages" size="sm"></pagination>
                                                </span>
                                                <span>
                                                    <div class="btn-group form-group-sm float-sm-right filter-button" dropdown [isDisabled]="loading">
                                                        <button id="button-basic" dropdownToggle type="button" class="btn btn-outline-default btn-sm dropdown-toggle" aria-controls="dropdown-basic">
                                                        Page Size : {{pageSize}} 
                                                        </button>
                                                        <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-basic">
                                                            <li role="menuitem"><a class="dropdown-item" (click)="setPageSize(10)">10</a></li>
                                                            <li role="menuitem"><a class="dropdown-item" (click)="setPageSize(100)">100</a></li>
                                                            <li role="menuitem"><a class="dropdown-item" (click)="setPageSize(200)">200</a></li>
                                                            <li role="menuitem"><a class="dropdown-item" (click)="setPageSize(1000)">1000</a></li>
                                                        </ul>
                                                    </div>
                                                </span> 
                                                
                                            </div>
                                        </div>
                                        <br/>
                                    </div>
                                    <div class="scroll">
                                        <table class="table table-small table-hover table-responsive">
                                            <thead>
                                                <tr>
                                                    <th scope="col"></th>
                                                    <th scope="col"></th>
                                                    <th scope="col">Site<i (click)="columnSort('siteName')" class="{{columnSortStyle('siteName')}}"></i></th>
                                                    <th scope="col">Time<i (click)="columnSort('time')" class="{{columnSortStyle('time')}}"></i></th>
                                                    <th scope="col d-none d-lg-table-cell text-truncate" *ngFor="let col of columns">
                                                        <i (click)="columnSort(col)" class="{{columnSortStyle(col)}}"></i>
                                                        {{col}}
                                                    </th>                                                    
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngIf="(results == null || results.length == 0) && !loading">
                                                    <td scope="row" colspan="5">No Time Series {{errorMessage}}</td>
                                                </tr>                                
                                                <tr *ngIf="(results == null || results.length == 0) && loading">
                                                    <td scope="row" colspan="5">Loading...</td>
                                                </tr>
                                                <tr *ngFor="let _input of results"><!-- | timeSeriesSort: sortColumn: sortDirection">-->
                                                    <td scope="row">
                                                        <button class="btn btn-outline-theme btn-sm mr-2" title="Quick View Dashboard" (click)="selectSite(_input);dashboard.show()" *ngIf="siteType.dashboards && siteType.dashboards.length > 0">
                                                            <i class="fa fa-eye"></i>
                                                        </button>
                                                        <a class="btn btn-outline-theme btn-sm" title="Open Dashboard" [routerLink]="['/dashboard/' + siteType.dashboards[0].dashboardId +'/' + _input.siteUri]" *ngIf="siteType.dashboards && siteType.dashboards.length > 0">
                                                            <i class="fa fa-external-link"></i>
                                                        </a>
                                                    </td>
                                                    <td>

                                                    </td>
                                                    <td class="text-truncate">
                                                        <a [routerLink]="['/site/' + siteTypeId +'/' + _input.siteUri]">{{_input.siteName}}</a>
                                                        <small class="d-xs-none" *ngIf="_input.siteDescription">
                                                            <br/>
                                                            {{_input.siteDescription }}
                                                        </small>
                                                    </td>   
                                                    <td class="no-break">
                                                        {{getTime(_input)}}
                                                    </td>
                                                    <td *ngFor="let col of columns" class="d-none d-lg-table-cell text-truncate">
                                                        {{getValue(_input, col)}} <small>{{getUnits(_input, col)}}</small>
                                                    </td>                                               
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </tab>
                        <tab heading="Virtual Time Series">
                            <div class="row mt-2 fixed">
                                <div class="col-lg-5">
                                    
                                    <div class="scroll">
                                        <table class="table table-small table-hover">
                                            <thead>
                                                <tr>
                                                    <th scope="col" class="col-1">#</th>
                                                    <th scope="col">Name</th>
                                                    <th scope="col">Site</th>
                                                    <th scope="col" class="col-1"><button *ngIf="azureAuthService.isAdmin() || azureAuthService.isOwner() || azureAuthService.isDashboardEditor()" (click)="addVirtual()" class="btn btn-sm"><i class="fa fa-plus"></i></button></th>                                                    
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngIf="virtualTimeSeries == null || virtualTimeSeries.length == 0; else vtsResults">
                                                    <td scope="row" colspan="4">
                                                        No Virtual Time Series Found
                                                    </td>                                                    
                                                </tr>
                                                <ng-template #vtsResults>
                                                    <tr *ngFor="let vts of virtualTimeSeries" [ngClass]="{'table-light': vts.id == selectedVirtualTimeSeries?.id}">
                                                        <td scope="row">{{vts.id}}</td>
                                                        <td>{{vts.name}}</td>
                                                        <td>{{vts.siteUri}}</td>
                                                        <td>
                                                            <button class="btn btn-sm" (click)="editVirtual(vts)"><i class="fa fa-pencil"></i></button>
                                                        </td>
                                                    </tr>
                                                </ng-template>
                                            </tbody>
                                        </table>    
                                    </div>

                                    <i>
                                        These Virtual Time Series are applied automatically to all sites of the type {{siteType?.siteTypeCode}} unless a site is specifically referenced.
                                    </i>
                                </div>
                                <div class="col-lg-7">
                                    <app-virtual-time-series-editor *ngIf="siteType" [siteType]="siteType" [virtualTimeSeries]="selectedVirtualTimeSeries"></app-virtual-time-series-editor>
                                </div>
                            </div>  
                        </tab>
                    </tabset>                    
                </div>
            </div>
        </div>

        
        <div class="modal modal-cover fade" bsModal #dashboard="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog" aria-labelledby="dialog-static-name">
            <div class="modal-dialog">
                <div class="modal-content">
                    <button type="button" class="btn-close position-fixed top-0 end-0 m-3" style="z-index: 9999;" aria-label="Close" (click)="dashboard.hide()"></button>
                    <div class="modal-body">                    
                        <app-dashboard #dashboardViewer [delayLoad]="true" [showEditor]="false"></app-dashboard>        
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

